import * as React from "react";

export default class Notification extends React.Component<any> {

    render() {

        var type = "alert-info";

        switch(this.props.nType){
            case "success" : {
                type = "alert-success";
                break;
            }
            case "warning" : {
                type = "alert-warning";
                break;
            }
            case "danger" : {
                type = "alert-danger";
                break;
            }
        }

        return (
            <div className = {"alert " + type}>
                <strong>{this.props.title}</strong> {this.props.message}
            </div>
        );
    }
}